import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_URL } from "../../app.config";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { editLetterDataApiCall } from "../../Store/slices/latterSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import {
  convertToBase64,
  convertToPNG,
  TOAST_ERROR,NUMBER_VALIDATION
} from "../../utils/common.service";
import * as API from "../../utils/api.service";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function EditLetter() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const clientData = location?.state?.clientData;
  const [categories, setCategories] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  useEffect(() => {
    const fetchCategories = async () => {
      dispatch(setLoader(true));
      try {
        const response = await API.getCategaryListApi();
        setCategories(response.data);
      } catch (error) {
        TOAST_ERROR("Failed to load categories");
      } finally {
        dispatch(setLoader(false));
      }
    };

    fetchCategories();
  }, [dispatch]);

  // State for profile images
  const [logoImageState, setLogoImageState] = useState(
    PUBLIC_URL + "/assets/images/default_logo.jpg"
  );
  const [letterImageState, setLetterImageState] = useState(
    PUBLIC_URL + "/assets/images/default_letter.jpg"
  );
  // const [backgroundImageState, setBackgroundImageState] = useState(
  //   PUBLIC_URL + "/assets/images/default_background.jpg"
  // );
  const [isFree, setIsFree] = useState(clientData?.is_free);

  // State for PNG images
  const [logoPng, setLogoPng] = useState(null);
  const [letterPng, setLetterPng] = useState(null);
  // const [backgroundPng, setBackgroundPng] = useState(null);

  useEffect(() => {
    if (clientData) {
      setLogoImageState(clientData?.logo);
      setLetterImageState(clientData?.latter_image);
      //setBackgroundImageState(clientData?.background_image);
      setIsFree(clientData?.is_free || false);
      reset({
        logoImage: clientData?.logo_name,
        letterImage: clientData?.letter_name,
        // backgroundImage: clientData?.background_image_name,
        skip_point: clientData?.skip_point ?? "",
        description: clientData?.description ?? "",
        ar_description: clientData?.ar_description ?? "",
        points: clientData?.points ?? "",
        category: clientData?.category ?? "",
        total_used_line: clientData.total_used_line ?? "",
      });
    }
  }, [clientData, reset]);

  const handleImageChange = async (image, field) => {
    try {
      if (image && image.size / 1024 > 3072) {
        TOAST_ERROR("Please select an image smaller than 3MB");
        return;
      }

      const bufferImage = await convertToBase64(image);
      setValue(field, image);

      switch (field) {
        case "logoImage":
          setLogoImageState(bufferImage);
          setLogoPng(await convertToPNG(image));
          break;
        case "letterImage":
          setLetterImageState(bufferImage);
          setLetterPng(await convertToPNG(image));
          break;
        // case "backgroundImage":
        //   setBackgroundImageState(bufferImage);
        //   setBackgroundPng(await convertToPNG(image));
        //   break;
        default:
          break;
      }
      clearErrors(field);
    } catch (e) {
      console.log("Image change error:", e);
    }
  };

  const onSubmit = async (submitData) => {
    dispatch(setLoader(true));
    try {
      let requestBody = {
        id: clientData?.id,
        logo: submitData.logoImage,
        latter_image: submitData.letterImage,
        //background_image: submitData.backgroundImage,
        is_free: isFree,
        skip_point: submitData.skip_point,
        description: submitData.description,
        ar_description: submitData.ar_description,
        points: submitData.points,
        category: submitData.category,
        total_used_line: submitData.total_used_line,
      };

      // Mapping fields to be uploaded
      const imageFieldMapping = {
        logoImage: "logo",
        letterImage: "latter_image",
        //backgroundImage: "background_image",
      };

      // Upload original images
      // for (const field of ["logoImage", "letterImage", "backgroundImage"]) {
      //   let image = submitData[field];
      //   if (image instanceof Blob) {
      //     const uploadedImageUrl = await uploadImageOnAWS(image, "letter");
      //     requestBody[imageFieldMapping[field]] = uploadedImageUrl;
      //   }
      // }

      for (const field of ["logoImage", "letterImage"]) {
        let image = submitData[field];
        if (image instanceof Blob) {
          const uploadedImageUrl = await uploadImageOnAWS(image, "letter");
          requestBody[imageFieldMapping[field]] = uploadedImageUrl;
        }
      }

      // Upload PNG versions of images if they exist
      const pngFieldMapping = {
        logoPng: "png_logo",
        letterPng: "png_latter_image",
        //backgroundPng: "png_background_image",
      };

      for (const [pngField, pngKey] of Object.entries(pngFieldMapping)) {
        if (pngField === "logoPng" && logoPng) {
          const pngUrl = await uploadImageOnAWS(logoPng, "letter");
          requestBody[pngKey] = pngUrl;
        } else if (pngField === "letterPng" && letterPng) {
          const pngUrl = await uploadImageOnAWS(letterPng, "letter");
          requestBody[pngKey] = pngUrl;
        }
        // else if (pngField === "backgroundPng" && backgroundPng) {
        //   const pngUrl = await uploadImageOnAWS(backgroundPng, "letter");
        //   requestBody[pngKey] = pngUrl;
        // }
      }

      // Dispatch the API call to update letter data
      await dispatch(editLetterDataApiCall(requestBody));

      // Navigate back to manage letter page
      navigate(`/manage_latter`);
      reset();
    } catch (err) {
      TOAST_ERROR(err.message);
    } finally {
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar
            title={`Edit Letter`}
            header={`letter`}
            subHeader={`Edit Letter`}
          />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                   <IoMdArrowRoundBack fontSize={"20px"}/>
                </button>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  {/* Logo Image */}
                  <div className="col-md-6 d-flex justify-content-center mb-3">
                    <Controller
                      name="logoImage"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={logoImageState}
                            alt="logo image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                          <label htmlFor="logoImage">
                            <div className="upload-document mt-2">
                              <div className="btn btn-outline-info m-1">
                                Choose Logo Image
                              </div>
                            </div>
                          </label>
                        </div>
                      )}
                    />
                    <input
                      type="file"
                      id="logoImage"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleImageChange(e.target.files[0], "logoImage")
                      }
                      accept="image/svg+xml"
                    />
                  </div>

                  {/* Letter Image */}
                  <div className="col-md-6 d-flex justify-content-center mb-3">
                    <Controller
                      name="letterImage"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={letterImageState}
                            alt="letter image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                          <label htmlFor="letterImage">
                            <div className="upload-document mt-2">
                              <div className="btn btn-outline-info m-1">
                                Choose Letter Image
                              </div>
                            </div>
                          </label>
                        </div>
                      )}
                    />
                    <input
                      type="file"
                      id="letterImage"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleImageChange(e.target.files[0], "letterImage")
                      }
                      accept="image/svg+xml"
                    />
                  </div>

                  {/* Background Image */}
                  {/* <div className="col-md-4 d-flex justify-content-center mb-3">
                    <Controller
                      name="backgroundImage"
                      control={control}
                      defaultValue={null}
                      render={({ field }) => (
                        <div className="d-flex flex-column align-items-center">
                          <img
                            src={backgroundImageState}
                            alt="background image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                          <label htmlFor="backgroundImage">
                            <div className="upload-document mt-2">
                              <div className="btn btn-outline-info m-1">
                                Choose Background Image
                              </div>
                            </div>
                          </label>
                        </div>
                      )}
                    />
                    <input
                      type="file"
                      id="backgroundImage"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleImageChange(e.target.files[0], "backgroundImage")
                      }
                      accept="image/svg+xml"
                    />
                  </div> */}

                  {/* Free Toggle */}
                  <div className="form-group mb-3 col-6">
                    <label className="form-label">Free</label>
                    <Controller
                      control={control}
                      name="isFree"
                      render={({ field }) => (
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="isFreeSwitch"
                            checked={isFree}
                            onChange={(e) => setIsFree(e.target.checked)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="isFreeSwitch"
                          >
                            {isFree ? "Yes" : "No"}
                          </label>
                        </div>
                      )}
                    />
                  </div>
                </div>

                {/* Category Dropdown */}
                {/* <div className="form-group mb-3 col-6">
                    <label className="form-label">Category</label>
                    <select
                      className="form-control"
                      {...register("category", {
                        required: "Category is required",
                      })}
                    >
                      <option value="">Select a Category</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category.name}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                    {errors.category && (
                      <p className="text-danger">{errors.category.message}</p>
                    )}
                  </div> */}
                <div className="row">
                  {/* Points Input */}
                  <div className="form-group mb-3 col-md-4">
                    <label className="form-label">Points</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("points",  NUMBER_VALIDATION("points"))}aria-invalid={errors.email ? "true" : "false"}
                      defaultValue={clientData?.points}
                    />
                    {errors.points && (
                      <p className="text-danger">{errors.points.message}</p>
                    )}
                  </div>

                  {/* Skip Points Input */}
                  <div className="form-group mb-3 col-md-4">
                    <label className="form-label">Skip Points</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("skip_point",  NUMBER_VALIDATION("skip points"))}aria-invalid={errors.email ? "true" : "false"}
                      defaultValue={clientData?.skip_point}
                    />
                    {errors.skip_point && (
                      <p className="text-danger">{errors.skip_point.message}</p>
                    )}
                  </div>

                  {/* total line  Input */}
                  <div className="form-group mb-3 col-md-4">
                    <label className="form-label">Total Line</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("total_used_line",NUMBER_VALIDATION("total line"))}aria-invalid={errors.email ? "true" : "false"}
                      defaultValue={clientData?.total_used_line}
                    />
                    {errors.skip_point && (
                      <p className="text-danger">
                        {errors.total_used_line.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="row">
                  {/* Description */}
                  <div className="form-group mb-3 col-12">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      {...register("description")}
                      defaultValue={clientData?.description}
                    />
                    {errors.description && (
                      <p className="text-danger">
                        {errors.description.message}
                      </p>
                    )}
                  </div>

                  <div className="form-group mb-3 col-12">
                    <label className="form-label">Description(Arabic)</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      {...register("ar_description")}
                      defaultValue={clientData?.ar_description}
                    />
                    {errors.description && (
                      <p className="text-danger">
                        {errors.ar_description.message}
                      </p>
                    )}
                  </div>

                  {/* Submit Button */}
                  <div className="col-12 text-center">
                    <button type="submit" className="btn btn-primary">
                      Update Letter
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
